'use strict'

const postcss = require( 'postcss' )
// var shorthandExpand = require('css-shorthand-expand')
import expand from './css-shorthand-expand/source'

export default postcss.plugin( 'postcss-shorthand-expand', () => {
	return ( root, result ) => {
		root.walkRules( function( rule ) {
			rule.walkDecls( function( declaration ) {
				if ( isShorthand( declaration.prop ) && isSupportedShorthand( declaration.prop ) ) {
					try {
						// Don't expand shorthand properties with a single value.
						if	( 	'margin' === declaration.prop ||
								'padding' === declaration.prop ||
								declaration.prop.includes( '-radius' ) ||
								declaration.prop.includes( 'border' ) ) {
							if ( declaration.value.includes( ' ' ) ) {
								const expandedDecls = expand( declaration.prop, declaration.value )

								Object.keys( expandedDecls ).forEach( function( prop ) {
									rule.insertBefore( declaration, { prop: prop, value: expandedDecls[ prop ] } )
								} )

								declaration.remove()
							}
						}
					} catch ( e ) {
						getExpansionFailureDescription( declaration, result )
					}
				}
			} )
		} )
	}
} )

// css-shorthand-expand doesn't yet support all shorthands
function isSupportedShorthand( shorthand ) {
	return [ 'background', 'font', 'padding', 'margin', 'border', 'border-width',
		'border-style', 'border-color', 'border-top', 'border-right', 'border-left',
		'border-bottom', 'border-radius' ].indexOf( shorthand ) >= 0
}

function getExpansionFailureDescription( decl, result ) {
	result.warn(
		'postcss-shorthand-expand failed to expand a property ' +
		decl.prop + ': ' + decl.value + ';',
		{ node: decl }
	)
}

function isShorthand( property ) {
	if ( typeof property !== 'string' ) {
		throw new TypeError( 'is-css-shorthand expected a string' )
	}

	const cssShorthandProperties = {
		// CSS 2.1: https://www.w3.org/TR/CSS2/propidx.html
		'list-style':      ['-type', '-position', '-image'],
		'margin':          ['-top', '-right', '-bottom', '-left'],
		'outline':         ['-width', '-style', '-color'],
		'padding':         ['-top', '-right', '-bottom', '-left'],

		// CSS Backgrounds and Borders Module Level 3: https://www.w3.org/TR/css3-background/
		'background':      ['-image', '-position', '-size', '-repeat', '-origin', '-clip', '-attachment', '-color'],
		'border':          ['-width', '-style', '-color'],
		'border-color':    ['border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color'],
		'border-style':    ['border-top-style', 'border-right-style', 'border-bottom-style', 'border-left-style'],
		'border-width':    ['border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width'],
		'border-top':      ['-width', '-style', '-color'],
		'border-right':    ['-width', '-style', '-color'],
		'border-bottom':   ['-width', '-style', '-color'],
		'border-left':     ['-width', '-style', '-color'],
		'border-radius':   ['border-top-left-radius', 'border-top-right-radius', 'border-bottom-right-radius', 'border-bottom-left-radius'],
		'border-image':    ['-source', '-slice', '-width', '-outset', '-repeat'],

		// CSS Fonts Module Level 3: https://www.w3.org/TR/css3-fonts/
		'font':            ['-style', '-variant', '-weight', '-stretch', '-size', 'line-height', '-family'],
		'font-variant':    ['-ligatures', '-alternates', '-caps', '-numeric', '-east-asian'],

		// CSS Flexible Box Layout Module Level 1: https://www.w3.org/TR/css3-flexbox-1/
		'flex':            ['-grow', '-shrink', '-basis'],
		'flex-flow':       ['flex-direction', 'flex-wrap'],

		// CSS Grid Layout Module Level 1: https://www.w3.org/TR/css-grid-1/
		'grid':            ['-template-rows', '-template-columns', '-template-areas', '-auto-rows', '-auto-columns', '-auto-flow'],
		'grid-template':   ['-rows', '-columns', '-areas'],
		'grid-row':        ['-start', '-end'],
		'grid-column':     ['-start', '-end'],
		'grid-area':       ['grid-row-start', 'grid-column-start', 'grid-row-end', 'grid-column-end'],
		'grid-gap':        ['grid-row-gap', 'grid-column-gap'],

		// CSS Masking Module Level 1: https://www.w3.org/TR/css-masking/
		'mask':            ['-image', '-mode', '-position', '-size', '-repeat', '-origin', '-clip'],
		'mask-border':     ['-source', '-slice', '-width', '-outset', '-repeat', '-mode'],

		// CSS Multi-column Layout Module: https://www.w3.org/TR/css3-multicol/
		'columns':         ['column-width', 'column-count'],
		'column-rule':     ['-width', '-style', '-color'],

		// CSS Scroll Snap Module Level 1: https://www.w3.org/TR/css-scroll-snap-1/
		'scroll-padding':            ['-top', '-right', '-bottom', '-left'],
		'scroll-padding-block':      ['-start', '-end'],
		'scroll-padding-inline':     ['-start', '-end'],
		'scroll-snap-margin':        ['-top', '-right', '-bottom', '-left'],
		'scroll-snap-margin-block':  ['-start', '-end'],
		'scroll-snap-margin-inline': ['-start', '-end'],

		// CSS Speech Module: https://www.w3.org/TR/css3-speech/
		'cue':             ['-before', '-after'],
		'pause':           ['-before', '-after'],
		'rest':            ['-before', '-after'],

		// CSS Text Decoration Module Level 3: https://www.w3.org/TR/css-text-decor-3/
		'text-decoration': ['-line', '-style', '-color'],
		'text-emphasis':   ['-style', '-color'],

		// CSS Animations (WD): https://www.w3.org/TR/css3-animations
		'animation':       ['-name', '-duration', '-timing-function', '-delay', '-iteration-count', '-direction', '-fill-mode', '-play-state'],

		// CSS Transitions (WD): https://www.w3.org/TR/css3-transitions/
		'transition':      ['-property', '-duration', '-timing-function', '-delay'],
	}

	return Object.keys(cssShorthandProperties).indexOf(property.toLowerCase()) !== -1
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/postcss/postcss-shorthand-expand.js